<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="filter_headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            
            :mobile-breakpoint="100"
            item-key="ID"
            show-select
            v-model="selected"
          >
          <!-- <template v-slot:header.TransactionCode="{ header }">
            <div>{{ header.text.split('|')[0] }}</div>
            <div>{{ header.text.split('|')[1] }}</div>
          </template> -->
            <template v-slot:item="{ item, isSelected, select }">
              <tr :id="'r-'+item.ID" :active="isSelected" v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                <td @click="select(!isSelected)" >
                  <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                </td>
                <td class="text-center">
                  <v-img v-if="item.ImageFiles" :src="item.ImageFiles[0]" width="64px" height="64px" style="cursor: pointer;" @click="showImageDialog(item)"></v-img>
                  <v-tooltip v-if="!item.ImageFiles">
                    <template v-slot:activator="{ on }">
                      <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                      <v-icon v-on="on" medium @click="showImageDialog(item)">fa-upload</v-icon>
                    </template>
                    <span>Up ảnh</span>
                  </v-tooltip>
                </td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.TransactionCode }}</td>
                <td v-if="item.BigPackageID > 0 && getBigPackage(item.BigPackageID) == ''">
                  {{item.PackageCode}}
                </td>
                <td v-else>
                  <v-edit-dialog
                    :return-value.sync="item.BigPackageID"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'BigPackageID': item.BigPackageID})"
                  >
                    <div>{{ item.PackageCode }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="packages"
                        v-model="item.BigPackageID"
                        item-text="PackageCode"
                        item-value="ID"
                        v-on:change="item.PackageCode = getBigPackage(item.BigPackageID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ProductName"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ProductName': item.ProductName})"
                  >
                    <div>{{ item.ProductName }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ProductName"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.NumberOfPack"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'NumberOfPack': item.NumberOfPack})"
                  >
                    <div>{{ item.NumberOfPack | currency}}</div>
                    <template v-slot:input>
                      <h-currency-input
                        v-model="item.NumberOfPack"
                        :decimal="0"
                        label="Số kiện"
                        autofocus
                      ></h-currency-input>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                    <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent @save="saveItem({'ID': item.ID, 'ProductType': item.ProductType})">
                        <div :class="'product-type-' + item.ProductType">{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</div>
                        <template v-slot:input>
                        <v-autocomplete
                            :items="product_types"
                            v-model="item.ProductType"
                            item-text="Name"
                            item-value="ID"
                        ></v-autocomplete>
                        </template>
                    </v-edit-dialog>
                </td>
                <td>{{ item.Username || 'Vô chủ' }}</td>
                <td>{{ item.OrderID > 0 ? (item.PackageType == 0 ? 'MD' : 'KG') + item.OrderID : ''}}</td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Weight"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Weight': item.Weight})"
                  >
                    <div>{{ item.Weight | currency('', 2) }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Weight"
                        type="number"
                        step=".1"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Length"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Length': item.Length})"
                  >
                    <div>{{ item.Length | currency('', 2) }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Length"
                        type="number"
                        step=".01"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Width"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Width': item.Width})"
                  >
                    <div>{{ item.Width | currency('', 2) }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Width"
                        type="number"
                        step=".01"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Height"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Height': item.Height})"
                  >
                    <div>{{ item.Height | currency('', 2) }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Height"
                        type="number"
                        step=".01"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">{{ item.Volume | currency('', 3) }}</td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                          </template>
                          <span>{{ item.StoreCNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.StoreCNNote" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center">
                  <!-- <v-edit-dialog
                    :return-value.sync="item.ImpLabel"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpLabel': item.ImpLabel})"
                  >
                    <div>{{ item.ImpLabel }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpLabel"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog> -->
                  <v-img v-if="item.ImpLabels" :src="item.ImpLabels[0]" width="64px" height="64px" style="cursor: pointer;" @click="showImageDialog(item, 'implabel')"></v-img>
                  <v-tooltip v-if="!item.ImpLabels">
                    <template v-slot:activator="{ on }">
                      <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                      <v-icon v-on="on" medium @click="showImageDialog(item, 'implabel')">fa-upload</v-icon>
                    </template>
                    <span>Up ảnh</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpMade"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpMade': item.ImpMade})"
                  >
                    <div>{{ item.ImpMade }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpMade"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpLogo"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpLogo': item.ImpLogo})"
                  >
                    <div>{{ item.ImpLogo }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpLogo"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpMaterial"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpMaterial': item.ImpMaterial})"
                  >
                    <div>{{ item.ImpMaterial }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpMaterial"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpModel"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpModel': item.ImpModel})"
                  >
                    <div>{{ item.ImpModel }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpModel"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.ImpQtyPiece"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpQtyPiece': item.ImpQtyPiece})"
                  >
                    <div>{{ item.ImpQtyPiece | currency }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpQtyPiece"
                        type="number"
                        step="1"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.ImpTotalQty"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpTotalQty': item.ImpTotalQty})"
                  >
                    <div>{{ item.ImpTotalQty | currency }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpTotalQty"
                        type="number"
                        step="1"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpSpec"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpSpec': item.ImpSpec})"
                  >
                    <div>{{ item.ImpSpec }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpSpec"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpProductDimensions"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpProductDimensions': item.ImpProductDimensions})"
                  >
                    <div>{{ item.ImpProductDimensions }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpProductDimensions"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpPower"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpPower': item.ImpPower})"
                  >
                    <div>{{ item.ImpPower }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpPower"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpWarning"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpWarning': item.ImpWarning})"
                  >
                    <div>{{ item.ImpWarning }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpWarning"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'FeeShip': item.FeeShip})"
                  >
                    <div>{{ item.FeeShip | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeShip"
                        type="number"
                        step=".1"
                        label="Phí ship"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.PackDate | display_date }}</td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ChinaStoreID"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ChinaStoreID': item.ChinaStoreID})"
                  >
                    <div>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</div>
                    <template v-slot:input>
                      <v-select label="Kho TQ" v-model="item.ChinaStoreID" :items="chinaStores" item-text="Name" item-value="ID"></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.ImpPack"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ImpPack': item.ImpPack})"
                  >
                    <div>{{ item.ImpPack }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ImpPack"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" v-if="(storeRole & 4)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xóa mã vận đơn</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialogCreateDeposit" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="title">Khớp đơn</span>
          </v-card-title>
          <v-card-text>
            <v-radio-group v-model="r_option" row>
              <v-radio label="Đơn ký gửi" value="r-deposit"></v-radio>
              <v-radio label="Đơn mua hộ" value="r-order"></v-radio>
            </v-radio-group>
            <v-layout row wrap v-if="r_option == 'r-deposit'">
              <v-flex lg12 pl-3 pr-3>
                <v-autocomplete label="Khách hàng" v-model="selectedCustomerID" :items="customers" :item-text="getCustomerText" item-value="ID"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex lg12 pl-3 pr-3>
                <v-autocomplete label="Đơn hàng" v-model="selectedOrderID" :items="matchOrders" :item-text="getOrderText" item-value="ID"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1 white--text" @click="dialogCreateDeposit = false">Đóng</v-btn>
            <v-btn color="red darken-1 white--text" @click="onCreateDepositOrder">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <store-popup
      :dialogStoreManager="dialogStoreManager"
      v-on:closePopup="closePopup"
      @deleteItem="deleteItem"
    ></store-popup>
    <export-cn
      v-on:closePopup="closePopup"
      :dialogExport="dialogExport"
    ></export-cn>
    <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/nhap_kho_tq.xlsx" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    <upload-media MaxFile="6" IsVPS="1" :ObjectType="fileType" :ObjectID="currentTransaction.ID" :dialogUpload="dialogMedia" title="Quản lý tệp" @closePopup="dialogMedia=false" @chooseMedia="chooseMedia"></upload-media>
    <image-viewer :activated="dialogViewer" :image_url="currentTransaction.ProductImage" @update:activated="dialogViewer = false"></image-viewer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import exportcn from "@/components/popups/exportcn";
import { sendErrorNotice, makeid } from "@/commons/utils";
import _ from "lodash";
import firebase from 'firebase';
import image_viewer from "@/components/popups/image_viewer";
import upload_file from "@/components/popups/upload_file";
import media from "@/components/popups/media";

export default {
  components: {
    "hpo-filter": Filtering,
    "upload-file": upload_file,
    "upload-media": media,
    'image-viewer': image_viewer,
    "store-popup": store,
    "export-cn": exportcn
  },
  data() {
    return {
      r_option: 'r-deposit',
      selected: [],
      selectedOrderID: 0,
      selectedCustomerID: 0,
      dialogCreateDeposit: false,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false,
      imageData: null,
      currentTransaction: {},
      hideImage: false,
      dialogViewer: false,
      dialogMedia: false,
      fileType: 'transaction',
      dialogExport: false,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data(false);
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    },
    product_types() {
        let header_item = _.find(this.headers, { value: "ProductType" });
        if (header_item) {
            header_item.values = _.map(this.product_types, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
            }) || []
        }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      chinaStores: (state) => state.commons.chinaStores,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
      customers: state => state.customer.master.data,
      product_types: state => state.productType.all.data,
      matchOrders: state => state.main_order.matchOrders.data,
    }),
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
    },
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    isChinessLanguage() {
      return false;
    },
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
        condition: "equal"
      });
      if(this.storeTQRole && this.$store.state.authentication.user.chinastoreid  && this.$store.state.authentication.user.chinastoreid.length > 0) {
        pr.filter.push({
          column: "ChinaStoreID",
          value: this.$store.state.authentication.user.chinastoreid,
          condition: "in"
        });
      }
      return pr;
    },
    headers() {
      let tmp = [
        {
          text: this.isChinessLanguage ? "Picture" : "Hình ảnh\n图片",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
          width: 64
        },
        {
          text: this.isChinessLanguage ? "进仓日期" : "Nhập kho\n进仓日期",
          value: "StoreCNImportDate",
          filterable: true,
          width: 90,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: this.isChinessLanguage ? "运单号" : "Mã vận đơn ..... 运单号",
          value: "TransactionCode",
          width: 120,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "编号" :  "Lô hàng ..... 编号",
          value: "PackageCode",
          width: 100,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "中文品名" :  "Tên hàng .... 中文品名",
          value: "ProductName",
          width: 100,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "件数" :  "Số kiện .. 件数",
          value: "NumberOfPack",
          filterable: true,
          width: 80,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "产品类别" :  "Loại hàng ... 产品类别",
          value: "ProductType",
          width: 100,
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: []
        },
        {
          text: this.isChinessLanguage ? "客户" :  "Khách hàng ... 客户",
          value: "Username",
          width: 100,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "订单编号" :  "Đơn hàng ... 订单编号",
          value: "OrderID",
          width: 100,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "重量" :  "Tổng KG . 重量",
          value: "Weight",
          width: 80,
          filterable: true,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "长" :  "Dài .. 长",
          value: "Length",
          filterable: true,
          width: 60,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "宽" :  "Rộng \n 宽",
          value: "Width",
          filterable: true,
          width: 60,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "高" :  "Cao .. 高",
          value: "Height",
          filterable: true,
          width: 60,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "体积" :  "Thể tích \n 体积",
          value: "Volume",
          width: 80,
          filterable: true,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "备注" :  "Ghi chú ...... 备注",
          value: "StoreCNNote",
          width: 100,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "标签" :  "Ê-ti-két",
          value: "ImpLabel",
          width: 80,
          filterable: false,
          sortable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "是否有" :  "Made in China\n是否有",
          value: "ImpMade",
          width: 120,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "品牌" :  "Logo ... 品牌",
          value: "ImpLogo",
          width: 80,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "材质" :  "Chất liệu\n材质",
          value: "ImpMaterial",
          width: 80,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "型号" :  "Model .. 型号",
          value: "ImpModel",
          width: 80,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "数量/件（PCS）" :  "Số lượng/kiện . 数量/件（PCS）",
          value: "ImpQtyPiece",
          width: 128,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "总数量（PCS）" :  "Tổng số lượng . 总数量（PCS）",
          value: "ImpTotalQty",
          width: 125,
          filterable: true,
          align: "right",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "规格（CM）" :  "Thông số kỹ thuật . 规格（CM）",
          value: "ImpSpec",
          width: 140,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "内部产品尺寸（CM）" :  "Kích thước sản phẩm . 内部产品尺寸（CM）",
          value: "ImpProductDimensions",
          width: 170,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "功率" :  "Công suất . 功率",
          value: "ImpPower",
          width: 100,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "警告" :  "Cảnh báo . 警告",
          value: "ImpWarning",
          width: 100,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "到付" :  "Phí ship . 到付",
          value: "FeeShip",
          width: 100,
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "装袋日期" :  "Ngày đóng bao . 装袋日期",
          value: "PackDate",
          width: 124,
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: this.isChinessLanguage ? "仓库" :  "Kho TQ ...... 仓库",
          value: "ChinaStoreID",
          width: 100,
          filterable: false,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: this.isChinessLanguage ? "包装" :  "Bao bì .. 包装",
          value: "ImpPack",
          width: 80,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "创作者" :  "Người tạo .. 创作者",
          value: "CreatedBy",
          width: 90,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "操作" :  "Thao tác . 操作",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ];
      return tmp;
    },
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: this.isChinessLanguage ? "加强" :  "Đóng gỗ - 加强",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: this.isChinessLanguage ? "校验" :  "Kiểm hàng - 校验",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: this.isChinessLanguage ? "保险" :  "Bảo hiểm - 保险",
          value: "OrderGuarantee",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: this.isChinessLanguage ? "正式" :  "Chính ngạch - 正式",
          value: "IsOfficialQuota",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: this.isChinessLanguage ? "电商" :  "TMĐT - 电商",
          value: "IsEcommerce",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
  },
  methods: {
    filter_data: function(isClearSelected = true) {
      if(isClearSelected) {
        this.selected = [];
      }
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", this.param);
      this.$store.dispatch("feeGuarantee/getList");
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.dialogExport = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    createDepositOrder() {
      this.dialogCreateDeposit = true;
      this.selectedCustomerID = 0;
    },
    onCreateDepositOrder() {
      let rightSeleted = _.filter(this.selected, (p) => {return !p.OrderID;});
      if(rightSeleted.length == 0) {
          sendErrorNotice("Hãy chọn danh sách mã vận đơn chưa khớp đơn!");
          return;
      }
      if(this.r_option == 'r-deposit') {
        let newOrder = {Status: 16};
        if(this.selectedCustomerID == 0) {
            sendErrorNotice("Hãy chọn khách hàng!");
            return;
        }
        const cust = _.find(this.customers, {'ID': this.selectedCustomerID});
        newOrder.UID = this.selectedCustomerID;
        newOrder.Username = cust.Username;
        newOrder.ReceivePlaceID = cust.ReceivePlaceID;
        newOrder.ChinaStoreID = cust.ChinaStoreID;
        newOrder.CustomerServiceID = cust.CustomerServiceID;
        newOrder.TransactionIDs = _.map(rightSeleted, "ID")

        this.$store.dispatch("deposit/setDetail", {'data': newOrder});
      }
      else {
        if(this.selectedOrderID == 0) {
            sendErrorNotice("Hãy chọn đơn hàng!");
            return;
        }
        this.$store.dispatch("orderTransaction/updateMultiple", {
          TransactionIDs: _.map(rightSeleted, "ID"),
          OrderID: this.selectedOrderID,
          PackageType: 0
        });
      }
      this.selected = []
      this.dialogCreateDeposit = false;
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    getOrderText(item) {
      return `${item.OrderCode} (${item.UserCode})`
    },
    importFileDialog() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
        const formData = new FormData();
        formData.append('excel_file', f);
        formData.append('filename', f.name);
        this.$store.dispatch("storeManager/import_transaction", formData);
      }
      this.dialogImport = false;
    },
    exportFile() {
      let rightSeleted = _.map(this.selected, "ID");
      if(rightSeleted.length == 0) {
          sendErrorNotice("Hãy chọn danh sách mã vận đơn để xuất file!");
          return;
      }
      let pr = {
        filter: [{
          column: "ID",
          value: rightSeleted,
          condition: "in"
        }],
        quickFilter: []
      };
      this.$store.dispatch("orderTransaction/export_vhk", pr);
    },
    chooseMedia(item) {
      // this.dialogMedia = true;
      // this.currentTransaction = item;
      // this.currentTransaction.ProductImage = '';
      // this.$refs.fileInput.click();
    },
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.$refs.fileInput.value = null;
      this.onUpload()
    },
    onUpload() {
      const arrFileType = this.imageData.name.split('.');
      const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
      storageRef.on(`state_changed`, snapshot => {
              
          },
          error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
          },
          () => {
              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                  this.currentTransaction.ProductImage =url;
                  this.hideImage = true;
                  this.$nextTick(() => this.hideImage = false);
                  this.$store.dispatch("orderTransaction/setDetail", {
                    data: {
                      ProductImage: this.currentTransaction.ProductImage
                    },
                    id: this.currentTransaction.ID
                  });
              });
          }
      );
    },
    showImageDialog(item, fileType = 'transaction') {
      this.currentTransaction = item;
      this.dialogMedia = true;
      this.fileType = fileType;
    },
    exportStore() {
      this.dialogExport = true;
    }
  },
  mounted() {
    this.$store.dispatch("productType/getList");
    this.$store.dispatch("main_order/getMatchOrders");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$store.dispatch("partner/getList");
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID"]
    });
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_SAVE_DATA", this.createDepositOrder);
    this.$root.$on("REQUEST_OTHER_ACTION", this.exportFile);
    this.$root.$on("REQUEST_OTHER_ACTION_2", this.exportStore);
    this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("REQUEST_OTHER_ACTION");
    this.$root.$off("REQUEST_OTHER_ACTION_2");
    this.$root.$off("REQUEST_IMPORT_ACTION");
  }
};
</script>
<style scoped>
.multi-line-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
